export default __webpack_public_path__ + "static/media/Q5-4.1a60b0d3.jpg";